import { render, staticRenderFns } from "./ongoing-examination.vue?vue&type=template&id=0d2756de&scoped=true"
import script from "./ongoing-examination.vue?vue&type=script&setup=true&lang=ts"
export * from "./ongoing-examination.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ongoing-examination.vue?vue&type=style&index=0&id=0d2756de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2756de",
  null
  
)

export default component.exports